//@ts-ignore webpack 5 require without *
import tinycolor from 'tinycolor2';
const min_temp = 10;
const min_color = '#15b1d9';
const high_temp = 27;
const high_color = '#d93d15';
const max_temp = 29;
const max_color = '#e00000';
export function calcTemp2Color(temp) {
    if (temp > max_temp) {
        return max_color;
    }
    if (temp > high_temp) {
        return high_color;
    }
    if (temp < min_temp) {
        return min_color;
    }
    let v = (temp - min_temp) / (max_temp - min_temp);
    v = (v - 0.5) * 2;
    v = v >= 0 ? 1 - Math.pow(1 - v, 3) : -1 + Math.abs(Math.pow(-1 - v, 3));
    v = (v + 1) / 2;
    const hsl = tinycolor(min_color).toHsl();
    hsl.h = hsl.h + v * -180;
    return tinycolor(hsl).toHexString();
}
